import { Select } from '@trackman/web-shared-components';
import { calculatorKinds } from 'constants/calculatorKinds';
import { useCallback, useState } from 'react';
import AceEditor from 'react-ace';
import { CalculatorKind } from 'types/calculator/calculatorType';
import { getCalcOptionsByType } from 'utilities/adminCalculatorOptions';

export type CalculatorLesson = { calculatorKind: CalculatorKind; calculatorOptions: string };
type Props = {
  lessonContent: CalculatorLesson;
  handleLessonContent: (lessonContent: CalculatorLesson) => void;
};

export const CalculatorLessonField = ({ lessonContent, handleLessonContent }: Props) => {
  const [jsonError, setJsonError] = useState<string>('');

  const validateJson = useCallback((inputString: string) => {
    setJsonError('');

    try {
      const parsedJSON = JSON.parse(inputString);

      handleLessonContent({ calculatorKind: lessonContent?.calculatorKind, calculatorOptions: JSON.stringify(parsedJSON) });
    } catch (e) {
      setJsonError('Invalid JSON, please check the syntax');
      return false;
    }
    return true;
  }, []);

  return (
    <>
      <Select
        label='Type'
        value={lessonContent?.calculatorKind ?? ''}
        onChange={(event) => {
          if (calculatorKinds.includes(event.target.value as CalculatorKind)) {
            const newLessonContent: CalculatorLesson = {
              calculatorKind: event.target.value as CalculatorKind,
              calculatorOptions: getCalcOptionsByType(event.target.value as CalculatorKind),
            };
            handleLessonContent(newLessonContent);
          }
        }}
        selectOptions={calculatorKinds.map((type) => {
          return {
            label: type,
            value: type,
          };
        })}
      />
      <AceEditor
        placeholder='Type the calculator settings in JSON format here'
        name='calculator-settings'
        onChange={(newValue) => validateJson(newValue)}
        fontSize={14}
        lineHeight={19}
        value={JSON.stringify(JSON.parse(lessonContent?.calculatorOptions ?? ''), null, 2) ?? ``}
      />
    </>
  );
};
